import { render, staticRenderFns } from "./TaskDetailsDialog.vue?vue&type=template&id=07f4aaeb&scoped=true"
import script from "./TaskDetailsDialog.vue?vue&type=script&lang=js"
export * from "./TaskDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f4aaeb",
  null
  
)

export default component.exports